import React, { Component } from 'react';
import { connect } from "react-redux";
import { Group, Stage, Layer, Rect, Line} from 'react-konva';

class Onsets extends Component {

    convertSecondsToSpace(x) {
        return x / this.props.buffer.duration * this.props.width
    }

    render() {
        let color = '#0062ff';
        if (!this.props.showingOnsets) {
            //color = '#000010';
            return [];
        }

        let onsets = this.props.sampler.onsets;
        return (
            onsets.map(
                (onset, i) => 
                     <Rect
                       key={"onset-" + i}
                       x={this.convertSecondsToSpace(onset / 1000.0 - this.props.zoomedStartTime)}
                       y={0}
                       width={this.isSelectedOnset(i) ? this.getOnsetWidth(i) : 1}
                       height={this.props.height}
                       opacity={this.isSelectedOnset(i) ? 0.4 : 1}
                       fill={this.isSelectedOnset(i) ? 'red' : color}
                        />
                )
        );
    }

    getOnsetWidth(i) {
        let onsets = this.props.sampler.onsets;
        if (i === onsets.length - 1) {
            return this.convertSecondsToSpace(
                this.props.sampler.getDuration() - (onsets[i] / 1000.0));
        }
        return this.convertSecondsToSpace((onsets[i+1] - onsets[i]) / 1000.0);
    }

    isSelectedOnset(i) {
        return this.props.selectedOnsets.indexOf(i) > -1;
    }
}

const mapStateToProps = (state, props) => {
    return {
        selectedOnsets: state.waveform.selectedOnsets[props.sampleId] || []
    };
};

export default connect(mapStateToProps, null)(Onsets);
